import { FC } from 'react'
import {ATTACHMENT_TYPE} from '../../models/post'

import {
  TExtendedPostAttachment
} from '../../store/managePost/newTypes'

import TrashIcon from '../UI/Icons/Trash'
import FbImageLibrary from '../FbImageLibrary'
import VideoPreview from '../UI/VideoPreview'
import { TCanvaPayload } from '../PostCreation/CanvaButton/CanvaButton'

type InstagramMedialItemProps = {
  attachment: TExtendedPostAttachment
  isEditable: boolean
  isPreview: boolean
  isMokup?: boolean
  onUpdateCanvaImage: (payload: TCanvaPayload) => void
  deattachAttachment: () => void
}

const InstagramMedialItem: FC<InstagramMedialItemProps> = ({
  attachment,
  isEditable,
  isPreview,
  isMokup = false,
  onUpdateCanvaImage,
  deattachAttachment
}) => {
  const isVideo = attachment.object_data?.options.type === ATTACHMENT_TYPE.TYPE_VIDEO
  const videoWidth = !isPreview ? 438
    : isMokup ? 125 : 365

  return (
    <div
      key={`multy-content-item-${'id' + attachment.id || 'tId' + attachment.temporaryId}`}
      className='multy-content-item'
    >
      {isVideo ? (
        <>
          <VideoPreview attachment={attachment} width={videoWidth} />
          {isEditable && (
            <div
              key={`post-video-${attachment.object_id}`}
              className='upload-video__video-wrapper__remove-item'
              onClick={deattachAttachment}
            >
              <TrashIcon />
            </div>
          )}
        </>
      ) : (
        <FbImageLibrary
          hideOverlay={true}
          firstImageHeight={100}
          isEditable={isEditable}
          images={[attachment]
            .filter(({ object_data }) => !!object_data)
            .map(({ object_data }) => object_data!)}
          onRemove={deattachAttachment}
          onUpdateCanvaImage={onUpdateCanvaImage}
        />
      )}
    </div>
  )
}

export default InstagramMedialItem
